export default "__VITE_ASSET__COywS1ie__"